/** Manage City / City Portal — City Transfer Requests tabs. */

export const CITY_TRANSFER_STATUS_TABS = [
  { key: "all", label: "All", countTone: "muted" },
  { key: "pending", label: "Pending", countTone: "awaiting" },
  { key: "approved", label: "Approved", countTone: "approved" },
  { key: "rejected", label: "Rejected", countTone: "rejected" },
]

export const CITY_TRANSFER_STATUS_FILTER_OPTIONS = [
  { value: "pending", label: "Pending" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
]
